<template>
  <div
    class="columns is-marginless has-padding-50 has-padding-bottom-400 is-multiline"
  >
    <div class="column is-12">
      <card>
        <template slot="header">
          <p class="card-header-title">
            <strong>Logs</strong>
          </p>
        </template>
        <template slot="body">
          <logs-table admin-context />
        </template>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminLogs",
  components: {
    "logs-table": () => import("@shared/logs/_logsTable")
  }
};
</script>
